/**
 * Liens Matière — force /pages/la-matiere (menu homepage, header Shopify, etc.)
 */
(function () {
  const paths = window.BioMatierePaths || {};

  function localeMatiereFallback() {
    const m = window.location.pathname.match(/^\/(fr-fr|en-us|es-es)(\/|$)/i);
    return m ? `/${m[1]}/pages/la-matiere` : '/pages/la-matiere';
  }

  function resolveMatiereUrl() {
    const fromLiquid = paths.matiere;
    if (fromLiquid && fromLiquid !== '/' && !fromLiquid.endsWith('://') && fromLiquid.includes('/pages/')) {
      return fromLiquid;
    }
    return localeMatiereFallback();
  }

  function isMatiereLink(anchor) {
    if (!anchor || anchor.tagName !== 'A') return false;
    if (anchor.hasAttribute('data-bio-nav-matiere')) return true;
    const label = (anchor.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return label === 'matière' || label === 'matiere';
  }

  function normalizeBrokenLocalePath(href) {
    if (!href) return href;
    return href
      .replace(/\/fr-frpages\//g, '/fr-fr/pages/')
      .replace(/\/en-uspages\//g, '/en-us/pages/')
      .replace(/\/es-espages\//g, '/es-es/pages/')
      .replace(/fr-frpages\//g, 'fr-fr/pages/')
      .replace(/en-uspages\//g, 'en-us/pages/')
      .replace(/es-espages\//g, 'es-es/pages/');
  }

  function fixHref(href) {
    const matiere = resolveMatiereUrl();
    if (!href) return matiere;

    let next = normalizeBrokenLocalePath(href);
    const root = window.location.origin + '/';

    if (
      next === '/' ||
      next === '' ||
      next === root ||
      next === window.location.origin ||
      (next.indexOf('/pages/matiere') !== -1 && next.indexOf('la-matiere') === -1)
    ) {
      return matiere;
    }

    try {
      const url = new URL(next, window.location.origin);
      if (url.pathname === '/' || url.pathname === '') return matiere;
      if (url.pathname.endsWith('/pages/matiere')) {
        const target = new URL(matiere, window.location.origin);
        url.pathname = target.pathname;
      }
      if (url.hash === '#teintes' || url.hash === '#nuancier') {
        return paths.nuancier || paths.echantillon || '/pages/echantillon#nuancier';
      }
      if (url.hash) return `${matiere}${url.hash}`;
      return url.pathname.includes('la-matiere') ? url.pathname + url.search + url.hash : matiere;
    } catch (e) {
      return matiere;
    }
  }

  function applyMatiereHref(anchor) {
    const target = fixHref(anchor.getAttribute('href'));
    if (target) anchor.setAttribute('href', target);
  }

  function patchLinks(root) {
    root.querySelectorAll('a').forEach((anchor) => {
      if (isMatiereLink(anchor)) applyMatiereHref(anchor);
      else if ((anchor.getAttribute('href') || '').indexOf('/pages/matiere') !== -1) {
        applyMatiereHref(anchor);
      }
    });

    root.querySelectorAll('[data-follow-link]').forEach((el) => {
      const raw = el.getAttribute('data-follow-link');
      if (!raw || raw.indexOf('matiere') === -1) return;
      const fixed = fixHref(raw);
      if (fixed) el.setAttribute('data-follow-link', fixed);
    });
  }

  function bindClickGuard() {
    document.addEventListener(
      'click',
      (e) => {
        const anchor = e.target.closest('a');
        if (!anchor || !isMatiereLink(anchor)) return;
        const dest = fixHref(anchor.getAttribute('href'));
        const href = anchor.getAttribute('href') || '';
        if (!dest || dest === href) return;
        if (href === '/' || href === '' || !href.includes('/pages/')) {
          e.preventDefault();
          window.location.assign(dest);
        }
      },
      true
    );
  }

  function run() {
    patchLinks(document);
  }

  bindClickGuard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) patchLinks(e.target);
  });
})();
